/** Why the camera can't be used, in words the usher can act on */
export function cameraErrorMessage(err: unknown, secure = window.isSecureContext): string {
  if (!secure || !navigator.mediaDevices?.getUserMedia) {
    return 'La cámara solo funciona en una conexión segura (https). Abra el sistema desde su dirección https.';
  }
  const name = err instanceof Error ? err.name : '';
  switch (name) {
    case 'NotAllowedError':
    case 'SecurityError':
      return 'Permiso de cámara denegado. Permita la cámara para este sitio en el navegador (ícono junto a la dirección) y reintente. En computadoras, revise también los permisos de cámara del sistema operativo.';
    case 'NotFoundError':
    case 'OverconstrainedError':
      return 'No se encontró una cámara en este dispositivo.';
    case 'NotReadableError':
    case 'AbortError':
      return 'La cámara está siendo usada por otra aplicación o pestaña. Ciérrela y reintente.';
    default:
      return 'No se pudo acceder a la cámara.';
  }
}
